import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: {
      accessToken: "",
      tokenType: "",
      userInfo: null,
    },
    // 权限信息
    privilege: {
      menuPaths: [],
      buttonCodes: [],
      // 作用域：按菜单 path -> 该菜单下允许的按钮 code 列表
      // 例如：{ '/interviewer/dashboard/schedule': ['btn_join', 'btn_assess'] }
      menuButtonCodesByPath: {},
    },
  },
  mutations: {
    setAuth(state, { accessToken, tokenType, userInfo } = {}) {
      state.auth.accessToken = accessToken || "";
      state.auth.tokenType = tokenType || "";
      state.auth.userInfo = userInfo || null;
    },
    clearAuth(state) {
      state.auth.accessToken = "";
      state.auth.tokenType = "";
      state.auth.userInfo = null;
      state.privilege.menuPaths = [];
      state.privilege.buttonCodes = [];
      state.privilege.menuButtonCodesByPath = {};
    },
    setPrivilege(state, { menuPaths = [], buttonCodes = [], menuButtonCodesByPath = {} } = {}) {
      state.privilege.menuPaths = menuPaths;
      state.privilege.buttonCodes = buttonCodes;
      state.privilege.menuButtonCodesByPath = menuButtonCodesByPath;
    },
  },
});
